module.exports = __webpack_public_path__ + "static/media/petite_fleche_degrade.ce68b403.svg";